export const events = {
  createNewJobStart: 'Create new job start',
  goToEmployeeWithoutJobTitleSubmit: 'Go to employee without job title submit',
  goToJobRoleFurtherInfoSubmit: 'Go to job role further info submit',
  createNewJobCancel: 'Create new job cancel',
  createNewJobNameRoleSubmit: 'Create new job name role submit',
  createNewJobLegalEntitiesSubmit: 'Create new job legal entities submit',
  createNewJobLevelSubmit: 'Create new job level submit',
  createNewJobAddLevelSubmit: 'Create new job add level submit',
  createNewJobSuccess: 'Create new job success',
  createNewJobSelectLegalEntitySubmit: 'Create new job select legal entity submit',
  deleteNewJobLevelSubmit: 'Delete new job level submit',
  goToPageViewJobs: 'Go to page view jobs',
  addJobRoleDescriptionSubmit: 'Add job role description submit',
  addJobRoleLegalEntityStart: 'Add job role legal entity start',
  deleteJobRoleLegalEntityStart: 'Delete job role legal entity start',
  createJobRoleNewLevelStart: 'Create job role new level start',
  addRoleSupervisorStart: 'Add role supervisor start',
  addRoleSupervisorSubmit: 'Add role supervisor submit',
  removeRoleSupervisorSubmit: 'Remove role supervisor submit',
  createJobLevelSalaryRangeStart: 'Create job level salary range start',
  chooseJobLevelSalaryRangeLevelSubmit: 'Choose job level salary range level submit',
  chooseJobLevelSalaryRangeLegalEntitySubmit: 'Choose job level salary range legal entity submit',
  chooseJobLevelSalaryRangeTypeSubmit: 'Choose job level salary range type submit',
  createJobLevelLegalEntitySubmit: 'Create job level legal entity submit',
  createJobLevelMinAmountSubmit: 'Create job level min amount submit',
  createJobLevelMaxAmountSubmit: 'Create job level max amount submit',
  createJobLevelSalaryRangeCancel: 'Create job level salary range cancel',
  createJobLevelSalaryRangeSuccess: 'Create job level salary range success',
  editJobLevelSalaryRangeSubmit: 'Edit job level salary range submit',
  removeJobLevelSalaryRangeStart: 'Remove job level salary range start',
  removeJobLevelSalaryRangeCancel: 'Remove job level salary range cancel',
  removeJobLevelSalaryRangeSuccess: 'Remove job level salary range success',
  previewJobLevelToggleSubmit: 'Preview job level toggle submit',
  createJobDescriptionStart: 'Create job description start',
  goToJobLevelSettingsSubmit: 'Go to job level settings submit',
  goToJobLevelPage: 'Go to job level page',
  jobRoleLevelPageEmployees: 'Job role level page employees',
  jobRoleLevelPageSalary: 'Job role level page salary',
  goToJobLevelEmployeeSubmit: 'Go to job level employee submit',
  editJobRoleLevelNameStart: 'Edit job role level name start',
  archiveJobRoleLevelStart: 'Archive job role level start',
  editJobRoleLevelCancel: 'Edit job role level cancel',
  editJobRoleLevelSuccess: 'Edit job role level success',
  archiveJobRoleLevelCancel: 'Archive job role level cancel',
  archiveJobRoleLevelSuccess: 'Archive job role level success',
  removeJobRoleLegalEntityCancel: 'Remove job role legal entity cancel',
  removeJobRoleLegalEntitySuccess: 'Remove job role legal entity success',
  addJobRoleLegalEntityCancel: 'Add job role legal entity cancel',
  addJobRoleLegalEntitySuccess: 'Add job role legal entity success',
  archiveJobRoleStart: 'Archive job role start',
  archiveJobRoleSubmit: 'Archive job role submit',
  archiveJobRoleCancel: 'Archive job role cancel',
  unarchiveJobRoleSubmit: 'Unarchive job role submit',
  filterByRoleStatus: 'Filter by role status',
  jobRolePageCompetencies: 'Job role page competencies',
  jobRolePageCareerPath: 'Job role page career path',
  jobRolePageCreateAndAssignCompetencyStart: 'Job role page create and assign competency start',
  jobRoleAddAndAssignCompetencyCancel: 'Job role create and assign competency cancel',
  jobRoleAddAndAssignCompetencySubmit: 'Job role create and assign competency submit',
  jobRolePageCompetencyEdit: 'Job role page competency edit',
  jobRolePageAssignCompetencyStart: 'Job role page assign competency start',
  jobRolePageCompetencyUnassign: 'Job role page competency unassign',
  jobRolePageCompetencyUnassignSubmit: 'Job role page competency unassign submit',
  jobRoleAssignCompetencyCancel: 'Job role assign competency cancel',
  jobRoleAssignCompetencySubmit: 'Job role assign competency submit',
  createAiCompetenciesStart: 'Create AI competencies start',
  createAiCompetenciesHintClose: 'Create AI competencies hint close',
  aiCompetenciesCreatedDelete: 'AI competencies created delete',
  assignAiCompetenciesCancel: 'Assign AI competencies Cancel',
  assignAiCompetenciesSubmit: 'Assign AI competencies Submit',
}
